<template>
  <div
    class="flex flex-col justify-between min-h-screen bg-primary relative overflow-hidden"
  >
    <div
      class="flex flex-col items-center justify-center flex-grow relative z-20"
    >
      <img
        class="papsi-mascot w-48 h-48 mb-10"
        src="https://resource.pafcpic.net/assets/pia/images/elements/papsi_kalabaw.png"
      />
      <span class="text-white font-bold text-2xl">
        {{ lang("lbl_0000037") }}
      </span>
      <span class="text-white text-lg mt-6 px-10 text-center">
        {{ lang("lbl_0000271") }}
      </span>
    </div>

    <div
      @click="this.$router.push('/dashboard')"
      class="bg-secondary text-primary font-bold text-center py-4 relative uppercase z-20"
    >
      {{ lang("lbl_0000251") }}
    </div>

    <div class="absolute z-10 papsi-overlay w-full h-full"></div>
    <img
      v-if="is_apple_device"
      src="https://resource.pafcpic.net/assets/papsi/LoginBG.jpg"
      class="absolute top-0 left-0 w-full h-full object-cover z-0"
    />
    <video
      v-else
      autoplay
      muted
      loop
      playsinline
      class="absolute top-0 left-0 w-full h-full object-cover z-0"
    >
      <source
        src="https://resource.pafcpic.net/assets/papsi/login_bg_video.mp4"
        type="video/mp4"
      />
    </video>
  </div>
</template>

<script>
import {
  isMobileSafari,
  isIOS,
  isIOS13,
  isIPad13,
  isIPhone13,
} from "mobile-device-detect";
import mixin from "./../../mixin.js";
export default {
  mixins: [mixin],
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("hidenavbar");
  },
  data() {
    return {
      is_apple_device:
        isMobileSafari || isIOS || isIOS13 || isIPad13 || isIPhone13,
    };
  },
};
</script>

<style scoped>
.object-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
}

.papsi-overlay {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #015200;
  opacity: 0.75;
}

.papsi-mascot {
  animation: mascot-wave 1s ease-in-out infinite;
  transform-origin: top center;
}
</style>
